import React,{useState,useEffect} from "react";
import styled from "styled-components";
import { Page ,FlexContainer} from "../../components/styled";
import CountdownBackground from "../../assets/images/countdownbackground.png";
import BattleCardsBackground from "../../assets/images/background/battlecardsbackground.png";
import DeckCard from "../../components/shared/deckCard";
import { useUserContext } from "../../context/UserContext";
import AtkImage from "../../assets/images/atkImage.png";
import Atkbackground from "../../assets/images/background/userAtkBackground.png";
import BattleResultBackgroundWin from "../../assets/images/background/battleResultBackgroundWin.png";
import BattleResultBackgroundLose from "../../assets/images/background/battleresultbackgroundlose.png";
import { slideInBottom } from "../../components/styled/animations";
import ProgressBar from "../../components/shared/progressBar";
import ReplayButton from "../../assets/images/replaybutton.png";
import GoHomeButton from "../../assets/images/gohomebutton.png";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../context/SocketContext";
import { useBattle } from "../../context/BattleContext";
import { Vibrate1 } from "../../components/styled/animations";
import { FlickerText,rotateScaleUp } from "../../components/styled/animations";



const Battle = () => {
    const [countdown,setCountdown] = useState(30);
    const {user} = useUserContext();
    const [hp,setHp] = useState(100);
    const {socket} = useSocket();
    const {battleData,isBattleEnded,battleResult} = useBattle();
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/");
    }
    const handleReplay = () => {
        navigate("/pvp");
    }

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                setHp(prev => prev - Math.floor(Math.random() * 2));
                return prev - 1;
            });
        },  1000);

        return () => clearInterval(timer);
    }, []);
    useEffect(() => {
        if(isBattleEnded){
            socket.disconnect();
        }
    },[socket,isBattleEnded])

    if(battleResult){
        return (
            <Page>
                <FlexContainer flexdirection="column" style={{height:"100%",background:"rgba(0, 0, 0, 0.2)",backdropFilter:"blur(10px)",position:"absolute"}}>
                    <BattleResultContainer>

                        <img style={{width:"100%",height:"100%"}} src={battleResult.winner._id === user._id ? BattleResultBackgroundWin : BattleResultBackgroundLose} alt="battle result background" />
                        <ResultContent>
                            <ResultItem won={battleResult.winner._id === user._id} top={battleResult.winner._id === user._id ? "61%" : "44.57%"}>
                                <img src={battleResult?.player1.telegramPhotoUri} alt="user profile" />
                                <span>@{battleResult?.player1.username}</span>
                                <span>{battleResult.player1.score || 0}</span>
                            </ResultItem>
                            <ResultItem won={battleResult.winner._id === user._id} top={battleResult.winner._id === user._id ? "77.8%" : "66.2%"}>
                                <img src={battleResult.player2?.telegramPhotoUri} alt="user profile" />
                                <span>@{battleResult.player2.username}</span>
                                <span>{battleResult.player2.score || 0}</span>
                            </ResultItem>
                        </ResultContent>
                        <ResultButtonsContainer>
                            <img onClick={handleGoHome} style={{width:"50%"}} src={GoHomeButton} alt="go home button" />
                            <img  onClick={handleReplay} style={{width:"52px"}} src={ReplayButton} alt="replay button" />
                        </ResultButtonsContainer>
                    </BattleResultContainer>
                </FlexContainer>
            </Page>
        )
    }
    return (
        <Page>
            <FlexContainer flexdirection="column" style={{height:"100%",position:"relative",overflowY:"auto",paddingBottom:"24px",justifyContent:"flex-start"}}>
                <Monster src={battleData.monster?.imageUri} alt="battle monster" />
            <CountdownContainer>
                <img alt="countdown" src={CountdownBackground} />
                <span>{countdown}</span>
            </CountdownContainer>
            <ProgressBarContainer>
                <h3>HP</h3>
                <ProgressBar 
                wrapperStyle={{height:"16px"}}
                progress={hp} />
            </ProgressBarContainer>
            <FlexContainer gap="2px">
                <CompetitorContainer>
                    <img style={{width:"100%",height:"100%"}} src={BattleCardsBackground} alt="battle cards background" />
                    <CompetitorInnercontainer>
                    <Atkcontainer>
                            <img src={Atkbackground} alt="user atk background" />
                            <AtkInnercontainer>
                                <img src={AtkImage} alt="user atk" />
                                <ScoreText key={battleData.player1.score}>{battleData.player1.score || 0}</ScoreText>
                            </AtkInnercontainer>
                        </Atkcontainer>
                        <Competitor>
                            <img src={battleData?.player1.telegramPhotoUri} alt="user profile" />
                            <span>{battleData?.player1.username}</span>
                        </Competitor>
                        <GridContainer>
                            {React.Children.toArray(
                                battleData.player1.cards.map((card, index) => (
                                    <RotatingWarapper>
                                   <AnimatedCard
                                    active={battleData.player1.card?._id === card._id}
                                    >
                                   <DeckCard 
                                   card={card}
                                   key={index}
                                   />
                                    </AnimatedCard>
                                    </RotatingWarapper>
                                ))
                            )}
                        </GridContainer>
                    </CompetitorInnercontainer>
                </CompetitorContainer>
                <CompetitorContainer>
                <img style={{width:"100%",height:"100%"}} src={BattleCardsBackground} alt="battle cards background" />
                    <CompetitorInnercontainer>
                        <Atkcontainer>
                            <img src={Atkbackground} alt="user atk background" />
                            <AtkInnercontainer>
                                <img src={AtkImage} alt="user atk" />
                                <ScoreText key={battleData.player2?.score}>{battleData.player2.score || 0}</ScoreText>
                            </AtkInnercontainer>
                        </Atkcontainer>
                    <Competitor>
                            <img src={battleData.player2?.telegramPhotoUri} alt="user profile" />
                            <span>{battleData.player2?.username}</span>
                        </Competitor>
                        <GridContainer>
                        {React.Children.toArray(
                            
                                battleData.player2.cards.map((card, index) => (
                                    <RotatingWarapper>
                                  <AnimatedCard
                                    active={battleData.player2.card?._id === card._id}
                                    >
                                        <DeckCard 
                                        card={card}
                                        key={index}
                                        />
                                    </AnimatedCard>
                                    </RotatingWarapper>
                                ))
                            )}
                        </GridContainer>
                    </CompetitorInnercontainer>
                </CompetitorContainer>
            </FlexContainer>
            </FlexContainer>
        </Page>
    );
}

const CountdownContainer = styled(FlexContainer)`
    width: 44px;
    height: 44px;
    position: absolute;
    top: 0;
    right: 8px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 100%;
        height: 100%;
    }
    span{
        position: absolute;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        text-shadow: 4px 4px 24px rgba(255, 255, 255, 0.34);
    }

`
const Monster = styled.img`
    width: 50vh;
    height: "auto";
    max-width: 245px;
    margin-top: 18%;
    animation: ${Vibrate1} 0.3s linear infinite both; 
`
const CompetitorContainer = styled(FlexContainer)`
    width: 100%;
    flex-direction: column;
    position: relative;
`
const CompetitorInnercontainer = styled(FlexContainer)`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    gap: 4px;
    padding:8px 16px;
    padding-top: 40px;  
    flex-direction: column;
    justify-content: flex-start;
`
const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    width: 100%;
`
const Competitor = styled(FlexContainer)`
    width: auto;
    gap: 8px;
    img{
        width: 26px;
        height: 26px;
        border-radius: 50%;
        border: 1.27px solid rgba(235, 132, 255, 0.67);
    }
`
const Atkcontainer = styled(FlexContainer)`
    position: absolute;
    top: -4px;
`
const AtkInnercontainer = styled(FlexContainer)`
    z-index: 1;
    position: absolute;
    gap: 4px;
    font-size: 22px;
    img{
        width: 19px;
    }
`
const BattleResultContainer = styled(FlexContainer)`
    width: 90%;
    animation:  ${slideInBottom} 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    position: relative;
`

const ResultContent = styled.div`
        position: absolute;
        top:0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;    
    `
const ResultItem = styled.div`
        position: absolute;
        top: ${(props) => props.top};
        left: ${(props) => props.won ? "22.7%" :"19.6%"};
        z-index: 1;
        display: flex;
        align-items: center;
        img{
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 1.27px solid rgba(235, 132, 255, 0.67);
        }
        span{
            margin-left: 8px;
            font-size: 16px;
        }
    `
const ProgressBarContainer = styled(FlexContainer)`
    width: 60%;
    position: absolute;
    top: 8px;
    flex-direction: column;
    gap: 4px;
    `
const ResultButtonsContainer = styled(FlexContainer)`
    width: 100%;
    position: absolute;
    bottom: -40px;
    gap: 8px;
    z-index: 1;
    img{
        cursor: pointer;
    }
`
const ScoreText = styled.span`
     animation: ${FlickerText} 1s linear both;
     font-size: 22px;
`
const RotatingWarapper = styled.div`
animation: ${rotateScaleUp} 0.65s linear both;
`
const AnimatedCard = styled.div`
    transition: transform 0.25s ease-in-out;
    transform: ${({ active }) => (active ? "scale(1.2)" : "scale(1)")};
`
export default Battle;